import React, { Component, Fragment } from 'react';
import { Form, Checkbox } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';
import _ from 'lodash';

import ReactTableWrapper from 'Common/ReactTableWrapper';
import { FilterEnum, ItemEnum, AssignEntitiesEnum } from 'Common/FieldEnum';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import EditableLabel from 'Components/editableLabel/EditableLabel';
import {
  ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME,
  ASSIGN_ENTITIES_FORM_NAME,
} from 'Common/FormEnum';
import { OrderPreferenceEnum } from 'Common/Constants/Enumeration/OrderPreferenceEnum';
import {
  ReactTableWrapperColumnProperties,
  UNSAVED_MESSAGE,
} from 'Common/Constants';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { getFilteredData } from 'Common/GridHelper';
import { ToolTipComponent } from 'Components';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';

import {
  ComponentMapping,
  getAllowPartialOrderingCheckboxData,
  getCheckedData,
  getCheckedGridData,
  getCheckedRefData,
  getComponentOnSelection,
  getFilteredIds,
  getOrderPreferenceId,
  GridNames,
  GridResetInitialValueEnum,
  updateRowCheckBox,
} from '../../../helper/assignEntities';
import {
  getItems,
  getSitesByItemId,
  getSiteGroupByItemId,
} from '../../../state/assignEntities/actions';
import * as Selectors from '../../../state/assignEntities/selectors';

class ItemGrid extends Component {
  static propTypes = {
    allItemsData: PropTypes.array.isRequired,
    allSitesData: PropTypes.array.isRequired,
    sitesByItemId: PropTypes.array.isRequired,
    siteGroupsByItemId: PropTypes.array.isRequired,
    dataSource: PropTypes.array.isRequired,
    resetGridPage: PropTypes.object.isRequired,
    onResetPageOnDataChange: PropTypes.func,
    onRightGridFilteredChange: PropTypes.func,
    setIsReadOnlyState: PropTypes.func,
    setItemGridInstance: PropTypes.func,
    onFilteredChange: PropTypes.func,
    getSitesByItemId: PropTypes.func.isRequired,
    getItems: PropTypes.func.isRequired,
    getSiteGroupByItemId: PropTypes.func.isRequired,

    isReadOnly: PropTypes.bool,
    direction: PropTypes.bool,
    loadingAllItems: PropTypes.bool.isRequired,
    rightSideGridReactTableRef: PropTypes.object,
    isStorageLocationPage: PropTypes.bool,
    isLeftSideItemGrid: PropTypes.bool,
    isRightSideSiteGrid: PropTypes.bool,
    isRightGridFiltered: PropTypes.bool,
    isLeftSideSiteGrid: PropTypes.bool,
    isRightSideItemGrid: PropTypes.bool,
    isRightSideSiteGroupGrid: PropTypes.bool,

    SiteGridInfo: PropTypes.array,
    itemGridInfo: PropTypes.array,
    groupId_Bid: PropTypes.number.isRequired,
    groupId_Item: PropTypes.number.isRequired,
    groupId_Cat: PropTypes.number.isRequired,
    groupId_Location: PropTypes.number.isRequired,
    vendorId: PropTypes.number,
    sortOptionsValue: PropTypes.string,
    dropDownValue: PropTypes.string,
    prepareInHouse: PropTypes.bool,
    loadingStorageLocationById: PropTypes.bool,
  };

  static defaultProps = {
    direction: true,
    isReadOnly: true,
    isStorageLocationPage: false,
    isLeftSideItemGrid: false,
    isRightSideSiteGrid: false,
    isRightGridFiltered: false,
    isLeftSideSiteGrid: false,
    isRightSideItemGrid: false,
    isRightSideSiteGroupGrid: false,
    rightSideGridReactTableRef: null,
    SiteGridInfo: [],
    itemGridInfo: [],
    onRightGridFilteredChange: () => {},
    onFilteredChange: () => {},
    setIsReadOnlyState: () => {},
    setItemGridInstance: () => {},
    onResetPageOnDataChange: () => {},
    loadingStorageLocationById: false,
    prepareInHouse: false,
    sortOptionsValue: AssignEntitiesEnum.Site,
    dropDownValue: AssignEntitiesEnum.FoodItems,
    vendorId: GenericEnum.InitialFilterValue,
  };

  state = {
    columns: [
      {
        Header: props => {
          const {
            dataSource,
            input: { value },
            isStorageLocationPage,
            rightSideGridReactTableRef,
            itemGridInfo,
          } = this.props;
          let check = false;
          if (
            isStorageLocationPage &&
            rightSideGridReactTableRef &&
            rightSideGridReactTableRef.current
          ) {
            const sortedData = rightSideGridReactTableRef.current.getResolvedState()
              .sortedData;
            check =
              sortedData.length > 0 &&
              sortedData.length ===
                getCheckedGridData(sortedData, itemGridInfo, ItemEnum.ItemId)
                  .length;
          } else if (
            rightSideGridReactTableRef &&
            rightSideGridReactTableRef.current
          ) {
            const sortedData = rightSideGridReactTableRef.current.getResolvedState()
              .sortedData;
            const checkedData = getCheckedData(
              getCheckedRefData(sortedData, ItemEnum.CheckBox),
              ItemEnum.CheckBox
            );
            check =
              sortedData.length > 0 && sortedData.length === checkedData.length;
          } else if (value && value.length && dataSource.length > 0) {
            check = isStorageLocationPage
              ? dataSource.length === value.length
              : dataSource.length ===
                getCheckedData(dataSource, ItemEnum.CheckBox).length;
          }
          return (
            <div>
              <Checkbox
                checked={check}
                onChange={(e, data) => {
                  isStorageLocationPage
                    ? this.handleHeaderLevelCheckBoxWithStorageLocation(
                        data.checked
                      )
                    : props &&
                      props.column &&
                      this.handleHeaderLevelCheckBox(
                        props.column.id,
                        data.checked
                      );
                }}
              />

              {this.props.isStorageLocationPage ? (
                ''
              ) : (
                <Fragment>
                  <br />
                  <div>Access</div>
                </Fragment>
              )}
            </div>
          );
        },
        Cell: ({ original }) => {
          const { isStorageLocationPage, input } = this.props;
          return (
            <div style={{ textAlign: 'center' }}>
              <Checkbox
                checked={
                  isStorageLocationPage
                    ? input.value.indexOf(original[ItemEnum.ItemId]) !== -1
                    : original.CheckBox
                }
                onChange={(e, data) => {
                  isStorageLocationPage
                    ? this.handleChangeCheckboxWithStorageLocation(
                        original,
                        data.checked
                      )
                    : this.handleChangeCheckbox(
                        original,
                        data.checked,
                        ItemEnum.CheckBox
                      );
                }}
              />
            </div>
          );
        },
        accessor: ItemEnum.CheckBox,
        ...ReactTableWrapperColumnProperties,
        sortable: false,
        filterable: false,
        visibilityName: 'Access',
        show:
          this.props.isRightSideItemGrid || this.props.isStorageLocationPage,
        visibility:
          this.props.isRightSideItemGrid || this.props.isStorageLocationPage,
        maxWidth: this.props.isStorageLocationPage ? 72 : 'auto',
      },
      {
        Header: () => {
          return (
            <span>
              Item <br />
              Code
            </span>
          );
        },
        visibilityName: 'Item Code',
        accessor: ItemEnum.ItemCode,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Description',
        accessor: ItemEnum.ItemDescription,
        width: 200,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Min. Par',
        accessor: ItemEnum.MinimumParLevel,
        ...ReactTableWrapperColumnProperties,
        show: this.props.isRightSideItemGrid,
        visibility: this.props.isRightSideItemGrid,
        Cell: rowInfo => {
          return this.props.isLeftSideItemGrid ? (
            <span> {rowInfo.original[ItemEnum.MinimumParLevel]}</span>
          ) : (
            <EditableLabel
              label={
                String(rowInfo.original[ItemEnum.MinimumParLevel])
                  ? rowInfo.original[ItemEnum.MinimumParLevel]
                  : ''
              }
              labelClassName={'qtyLabel'}
              refData={rowInfo.original}
              inputType={'text'}
              onChange={this.handleChangeMinPar}
              allowEdit={true}
              className={'ht-26 mt--5'}
              disabled={!rowInfo.original[ItemEnum.CheckBox]}
            />
          );
        },
      },
      {
        Header: 'Max. Par',
        accessor: ItemEnum.MaximumParLevel,
        ...ReactTableWrapperColumnProperties,
        show: this.props.isRightSideItemGrid,
        visibility: this.props.isRightSideItemGrid,
        Cell: rowInfo => {
          return this.props.isLeftSideItemGrid ? (
            <span>{rowInfo.original[ItemEnum.MaximumParLevel]}</span>
          ) : (
            <EditableLabel
              label={
                String(rowInfo.original[ItemEnum.MaximumParLevel])
                  ? rowInfo.original[ItemEnum.MaximumParLevel]
                  : ''
              }
              labelClassName={'qtyLabel'}
              refData={rowInfo.original}
              inputType={'text'}
              onChange={this.handleChangeMaxPar}
              allowEdit={true}
              className={' ht-26 mt--5'}
              disabled={!rowInfo.original[ItemEnum.CheckBox]}
            />
          );
        },
      },
      {
        Header: props => {
          const {
            dataSource,
            input: { value },
            isStorageLocationPage,
          } = this.props;
          let check = false;
          if (value && value.length && dataSource.length > 0) {
            check = isStorageLocationPage
              ? dataSource.length === value.length
              : dataSource.length ===
                getCheckedData(value, ItemEnum.VendorAllowed).length;
          }
          return (
            <div>
              <Checkbox
                checked={check}
                onChange={(e, data) => {
                  props &&
                    props.column &&
                    this.handleHeaderLevelCheckBox(
                      props.column.id,
                      data.checked
                    );
                }}
              />
              <br />
              <div>
                Distributor
                <br />
                Allowed
              </div>
            </div>
          );
        },
        accessor: ItemEnum.VendorAllowed,
        ...ReactTableWrapperColumnProperties,
        show: this.props.isRightSideItemGrid,
        visibility: this.props.isRightSideItemGrid,
        sortable: false,
        filterable: false,
        visibilityName: 'Distributor Allowed',
        Cell: ({ original }) => {
          return (
            <div style={{ textAlign: 'center' }}>
              <Checkbox
                checked={original.VendorAllowed}
                onChange={(e, data) => {
                  this.handleChangeCheckbox(
                    original,
                    data.checked,
                    ItemEnum.VendorAllowed
                  );
                }}
              />
            </div>
          );
        },
      },
      {
        Header: props => {
          const {
            dataSource,
            input: { value },
            isStorageLocationPage,
          } = this.props;
          let check = false;
          if (value && value.length && dataSource.length > 0) {
            check = isStorageLocationPage
              ? dataSource.length === value.length
              : dataSource.length ===
                getCheckedData(value, ItemEnum.VendorOnly).length;
          }
          return (
            <div>
              <Checkbox
                checked={check}
                onChange={(e, data) => {
                  props &&
                    props.column &&
                    this.handleHeaderLevelCheckBox(
                      props.column.id,
                      data.checked
                    );
                }}
              />
              <br />
              <div>
                Distributor
                <br />
                Only
              </div>
            </div>
          );
        },
        accessor: ItemEnum.VendorOnly,
        ...ReactTableWrapperColumnProperties,
        visibilityName: 'Distributor Only',
        show: this.props.isRightSideItemGrid,
        visibility: this.props.isRightSideItemGrid,
        sortable: false,
        filterable: false,
        Cell: ({ original }) => {
          return (
            <div style={{ textAlign: 'center' }}>
              <Checkbox
                checked={original.VendorOnly}
                onChange={(e, data) => {
                  this.handleChangeCheckbox(
                    original,
                    data.checked,
                    ItemEnum.VendorOnly
                  );
                }}
              />
            </div>
          );
        },
      },
      {
        Header: props => {
          const {
            input: { value },
          } = this.props;
          let check = false;
          const len = getAllowPartialOrderingCheckboxData(value).length;
          if (value && value.length) {
            check =
              len > 0 &&
              getCheckedData(value, ItemEnum.AllowPartialOrderingSite).length >=
                len;
          }
          return (
            <div>
              <Checkbox
                checked={check}
                onChange={(e, data) => {
                  props &&
                    props.column &&
                    this.handleHeaderLevelAPOSiteCheckBox(
                      props.column.id,
                      data.checked
                    );
                }}
              />
              <br />
              <div>
                Allow Ordering
                <br />
                Pack Qty
              </div>
            </div>
          );
        },
        accessor: ItemEnum.AllowPartialOrderingSite,
        ...ReactTableWrapperColumnProperties,
        filterable: false,
        sortable: false,
        show: this.props.isRightSideItemGrid,
        visibility: this.props.isRightSideItemGrid,
        Cell: ({ original }) => {
          return (
            <div style={{ textAlign: 'center' }}>
              {original[ItemEnum.AllowPartialOrdering] ? (
                <Checkbox
                  checked={original[ItemEnum.AllowPartialOrderingSite]}
                  disabled={
                    !original[ItemEnum.AllowPartialOrdering] ||
                    !original[ItemEnum.CheckBox]
                  }
                  onChange={(e, data) => {
                    this.handleChangeCheckbox(
                      original,
                      data.checked,
                      ItemEnum.AllowPartialOrderingSite
                    );
                  }}
                />
              ) : (
                <ToolTipComponent
                  label={' N/A '}
                  popMessage={
                    'Allow Ordering Pack Qty. is disabled from Item maintenance.'
                  }
                  iconName="question circle outline"
                />
              )}
            </div>
          );
        },
      },
      {
        Header: () => {
          return (
            <span>
              Exclusive
              <br />
              Ordering Site
            </span>
          );
        },
        accessor: ItemEnum.ExclusiveOrderingSite,
        ...ReactTableWrapperColumnProperties,
        show: this.props.isRightSideItemGrid,
        visibility: this.props.isRightSideItemGrid,
      },
    ],
    showUnsavedModal: false,
    rowInfo: null,
  };
  handleUnsavedModal(result) {
    const { direction, sortOptionsValue, dropDownValue } = this.props;
    const renderedComponent = getComponentOnSelection(
      sortOptionsValue,
      dropDownValue,
      direction
    );
    if (result) {
      this.props.setIsReadOnlyState(true);
      this.getAssociatedGridDetails();
      if (
        renderedComponent === ComponentMapping.SiteToItemsComponents ||
        renderedComponent === ComponentMapping.SiteGroupToItemsComponents
      ) {
        this.props.onResetPageOnDataChange({
          ...GridResetInitialValueEnum,
          [GridNames.Site]: false,
          [GridNames.Item]: true,
        });
      } else if (
        renderedComponent === ComponentMapping.ItemToSitesComponents ||
        renderedComponent === ComponentMapping.ItemToSiteGroupsComponents
      ) {
        this.props.onResetPageOnDataChange({
          ...GridResetInitialValueEnum,
          [GridNames.Site]: true,
          [GridNames.Item]: false,
        });
      }
    } else {
      if (
        renderedComponent === ComponentMapping.SiteToItemsComponents ||
        renderedComponent === ComponentMapping.ItemToSitesComponents ||
        renderedComponent === ComponentMapping.SiteGroupToItemsComponents ||
        renderedComponent === ComponentMapping.ItemToSiteGroupsComponents
      ) {
        this.props.onResetPageOnDataChange({
          ...GridResetInitialValueEnum,
          [GridNames.Site]: false,
          [GridNames.Item]: false,
        });
      }
    }
    this.setState({
      showUnsavedModal: false,
      rowInfo: null,
    });
  }
  handleChangeMinPar = (refData, newValue) => {
    this.handleParLevelChange(refData, newValue, ItemEnum.MinimumParLevel);
  };
  handleChangeMaxPar = (refData, newValue) => {
    this.handleParLevelChange(refData, newValue, ItemEnum.MaximumParLevel);
  };
  handleParLevelChange = (refData, newValue, fieldName) => {
    newValue = newValue.match(/\d{0,6}(\.\d{0,3})?/)[0];
    const formValues =
      this.props.input.value && this.props.input.value.length
        ? _.cloneDeep(this.props.input.value)
        : [];
    const index = _.findIndex(formValues, formValue => {
      return formValue[ItemEnum.ItemId] === refData[ItemEnum.ItemId];
    });
    if (index > -1) {
      formValues[index][fieldName] = newValue;
    } else {
      const newFiled = Object.assign({}, refData);
      newFiled[fieldName] = newValue;
      formValues.push(newFiled);
    }
    this.props.setIsReadOnlyState(false);
    this.props.input.onChange(formValues);
  };
  handleHeaderLevelCheckBox = (columnName, checked) => {
    const {
      dataSource,
      isLeftSideItemGrid,
      input: { value },
      rightSideGridReactTableRef,
    } = this.props;
    let dataSourceCopy =
      dataSource && dataSource.length ? _.cloneDeep(dataSource) : [];
    if (value && value.length && dataSourceCopy && dataSourceCopy.length) {
      _.each(value, formValue => {
        const index = _.findIndex(dataSourceCopy, {
          [ItemEnum.ItemId]: formValue[ItemEnum.ItemId],
        });
        if (index > -1) {
          dataSourceCopy[index] = { ...formValue };
        }
      });
    }
    if (rightSideGridReactTableRef && rightSideGridReactTableRef.current) {
      const filteredData = rightSideGridReactTableRef.current.getResolvedState()
        .sortedData;
      _.each(filteredData, filterItem => {
        const index = _.findIndex(dataSourceCopy, {
          [ItemEnum.ItemId]: filterItem._original[ItemEnum.ItemId],
        });
        if (index > -1) {
          dataSourceCopy[index] = filterItem._original
            ? updateRowCheckBox(filterItem._original, columnName, checked)
            : updateRowCheckBox(filterItem, columnName, checked);
        }
      });
    } else if (dataSourceCopy && dataSourceCopy.length) {
      dataSourceCopy = dataSourceCopy.map(data => {
        return updateRowCheckBox(data, columnName, checked);
      });
    }
    this.props.setIsReadOnlyState(false);
    !isLeftSideItemGrid &&
      dataSourceCopy &&
      dataSourceCopy.length &&
      this.props.input.onChange(dataSourceCopy);
  };

  handleHeaderLevelAPOSiteCheckBox = (columnName, checked) => {
    const {
      input: { value },
      isLeftSideItemGrid,
    } = this.props;
    let valueCopy = value && value.length ? _.cloneDeep(value) : [];
    const isHeaderLevelAllowOrderingSite = true;
    valueCopy = valueCopy.map(data => {
      return updateRowCheckBox(
        data,
        columnName,
        checked,
        isHeaderLevelAllowOrderingSite
      );
    });
    this.props.setIsReadOnlyState(false);
    !isLeftSideItemGrid &&
      valueCopy &&
      valueCopy.length &&
      this.props.input.onChange(valueCopy);
  };
  componentDidMount() {
    const {
      getItems,
      isRightSideSiteGrid,
      isRightSideSiteGroupGrid,
      getSitesByItemId,
      isLeftSideItemGrid,
      getSiteGroupByItemId,
      isStorageLocationPage,
    } = this.props;
    if (!isStorageLocationPage && isLeftSideItemGrid) {
      getItems().then(() => {
        this.props.onResetPageOnDataChange({
          ...GridResetInitialValueEnum,
          [GridNames.Item]: false,
          [GridNames.Site]: true,
        });
        const { allItemsData } = this.props;
        isRightSideSiteGrid &&
          allItemsData &&
          getSitesByItemId([allItemsData[0][ItemEnum.ItemId]]);

        isRightSideSiteGroupGrid &&
          allItemsData &&
          getSiteGroupByItemId(allItemsData[0][ItemEnum.ItemId]);
        this.props.input.onChange([allItemsData[0][ItemEnum.ItemId]]);
      });
    } else if (isStorageLocationPage) {
      this.props.onResetPageOnDataChange({
        [GridNames.Site]: true,
        [GridNames.Item]: true,
      });
    }
  }
  componentDidUpdate(prevProps) {
    const {
      isLeftSideSiteGrid,
      isRightSideItemGrid,
      isStorageLocationPage,
    } = this.props;
    if (isRightSideItemGrid && isLeftSideSiteGrid && !isStorageLocationPage) {
      const site = getOrderPreferenceId(
        this.props.allSitesData,
        this.props.SiteGridInfo
      );
      if (
        prevProps.SiteGridInfo &&
        !_.isEqual(prevProps.SiteGridInfo, this.props.SiteGridInfo) &&
        site &&
        site.OrderPreferenceId === OrderPreferenceEnum.vendorOnly
      ) {
        const columns = _.cloneDeep(this.state.columns);
        _.forEach(columns, clm => {
          if (
            clm.accessor === ItemEnum.VendorAllowed ||
            clm.accessor === ItemEnum.VendorOnly ||
            clm.accessor === ItemEnum.ExclusiveOrderingSite
          ) {
            clm.show = false;
            clm.visibility = false;
          }
        });
        this.setState({
          columns,
        });
      } else if (
        prevProps.SiteGridInfo &&
        !_.isEqual(prevProps.SiteGridInfo, this.props.SiteGridInfo) &&
        site &&
        site.OrderPreferenceId !== OrderPreferenceEnum.vendorOnly
      ) {
        const columns = _.cloneDeep(this.state.columns);
        _.forEach(columns, clm => {
          if (
            clm.accessor === ItemEnum.VendorAllowed ||
            clm.accessor === ItemEnum.VendorOnly ||
            clm.accessor === ItemEnum.ExclusiveOrderingSite
          ) {
            clm.show = true;
            clm.visibility = true;
          }
        });
        this.setState({
          columns,
        });
      }
    }
  }

  componentWillUnmount() {
    this.props.input.onChange([]);
  }

  handleHeaderLevelCheckBoxWithStorageLocation = checked => {
    const {
      rightSideGridReactTableRef,
      isRightGridFiltered,
      isStorageLocationPage,
      itemGridInfo,
      dataSource,
    } = this.props;

    if (
      isStorageLocationPage &&
      isRightGridFiltered &&
      rightSideGridReactTableRef &&
      rightSideGridReactTableRef.current
    ) {
      const sortedData = rightSideGridReactTableRef.current.getResolvedState()
        .sortedData;
      const sortedItemsData = getFilteredIds(sortedData, ItemEnum.ItemId);
      let itemGridInfoCopy = [...itemGridInfo];
      let itemsToChange;
      if (checked) {
        itemsToChange = _.union(sortedItemsData, itemGridInfoCopy);
      } else {
        _.remove(itemGridInfoCopy, itemId => {
          return sortedItemsData.includes(itemId);
        });
        itemsToChange = itemGridInfoCopy;
      }
      this.props.input.onChange(itemsToChange);
    } else {
      const itemIds = checked
        ? dataSource.map(item => {
            return item[ItemEnum.ItemId];
          })
        : [];
      this.props.input.onChange(itemIds);
    }
    this.props.setIsReadOnlyState(false);
  };

  handleChangeCheckboxWithStorageLocation = (original, checked) => {
    const formValues =
      this.props.input.value && this.props.input.value.length
        ? _.cloneDeep(this.props.input.value)
        : [];
    let index = formValues.indexOf(original[ItemEnum.ItemId]);
    if (checked) {
      index === -1 && formValues.push(original[ItemEnum.ItemId]);
    } else {
      if (index !== -1) {
        formValues.splice(index, 1);
      }
    }
    this.props.setIsReadOnlyState(false);
    this.props.input.onChange(formValues);
  };

  handleChangeCheckbox = (data, checkBoxValue, columnName) => {
    const formValues =
      this.props.input.value && this.props.input.value.length
        ? _.cloneDeep(this.props.input.value)
        : [];
    const index = _.findIndex(formValues, formValue => {
      return formValue[ItemEnum.ItemId] === data[ItemEnum.ItemId];
    });
    let original;
    if (columnName === ItemEnum.AllowPartialOrderingSite) {
      if (index > -1) {
        formValues[index][columnName] = checkBoxValue;
      } else {
        const newFiled = Object.assign({}, data);
        newFiled[columnName] = checkBoxValue;
        formValues.push(newFiled);
      }
    } else {
      if (index > -1) {
        original = updateRowCheckBox(
          formValues[index],
          columnName,
          checkBoxValue
        );
        formValues[index] = original;
      } else {
        const newFiled = { ...data };
        original = updateRowCheckBox(newFiled, columnName, checkBoxValue);
        formValues.push(original);
      }
    }
    this.props.setIsReadOnlyState(false);
    this.props.input.onChange(formValues);
  };

  prepareTableData = () => {
    const {
      groupId_Cat,
      groupId_Bid,
      groupId_Item,
      prepareInHouse,
      vendorId,
      groupId_Location,
    } = this.props;
    let dataSourceCopy =
      this.props.dataSource && this.props.dataSource.length
        ? _.cloneDeep(this.props.dataSource)
        : [];
    const { value } = this.props.input;
    if (value && value.length && dataSourceCopy && dataSourceCopy.length) {
      _.each(value, item => {
        const index = _.findIndex(dataSourceCopy, {
          [ItemEnum.ItemId]: item[ItemEnum.ItemId],
        });
        if (index > -1) {
          const dataRow = { ...item };
          dataSourceCopy[index][ItemEnum.CheckBox] = dataRow[ItemEnum.CheckBox];
          dataSourceCopy[index][ItemEnum.VendorAllowed] =
            dataRow[ItemEnum.VendorAllowed];
          dataSourceCopy[index][ItemEnum.VendorOnly] =
            dataRow[ItemEnum.VendorOnly];
          dataSourceCopy[index][ItemEnum.MinimumParLevel] =
            dataRow[ItemEnum.MinimumParLevel];
          dataSourceCopy[index][ItemEnum.MaximumParLevel] =
            dataRow[ItemEnum.MaximumParLevel];
          dataSourceCopy[index][ItemEnum.AllowPartialOrderingSite] =
            dataRow[ItemEnum.AllowPartialOrderingSite];
        }
      });
    }
    const propFiltersValue = {
      [FilterEnum.GroupId_Cat]: groupId_Cat,
      [FilterEnum.GroupId_Bid]: groupId_Bid,
      [FilterEnum.GroupId_Item]: groupId_Item,
      [FilterEnum.PrepareInHouse]: prepareInHouse,
      [FilterEnum.VendorId]: vendorId,
    };
    const gridFilterValues = {};
    _.map(propFiltersValue, (value, key, items) => {
      if (+items[key]) {
        gridFilterValues[key] = items[key];
      }
    });
    if (groupId_Location) {
      dataSourceCopy = getFilteredData(gridFilterValues, dataSourceCopy);
      dataSourceCopy = _.filter(dataSourceCopy, item => {
        if (Array.isArray(item[ItemEnum.StorageLocationIds])) {
          return item[ItemEnum.StorageLocationIds].includes(
            String(groupId_Location)
          );
        }
      });
    } else {
      dataSourceCopy = getFilteredData(gridFilterValues, dataSourceCopy);
    }
    return dataSourceCopy;
  };

  getAssociatedGridDetails = () => {
    const {
      isRightSideSiteGroupGrid,
      isRightSideSiteGrid,
      getSitesByItemId,
      getSiteGroupByItemId,
    } = this.props;
    const { rowInfo } = this.state;
    if (rowInfo && rowInfo.original) {
      if (isRightSideSiteGroupGrid) {
        this.props.input.onChange([rowInfo.original[ItemEnum.ItemId]]);
        getSiteGroupByItemId(rowInfo.original[ItemEnum.ItemId]);
      } else if (isRightSideSiteGrid) {
        this.props.input.onChange([rowInfo.original[ItemEnum.ItemId]]);
        getSitesByItemId(rowInfo.original[ItemEnum.ItemId]);
      }
    }
  };

  onRowClickProp = (state, rowInfo) => {
    const {
      isRightSideItemGrid,
      isLeftSideItemGrid,
      isStorageLocationPage,
    } = this.props;
    let styleObj = {};
    const style = {
      color: '#df5a17',
      fontWeight: '600',
    };
    if (
      isLeftSideItemGrid &&
      !isStorageLocationPage &&
      this.props.input.value &&
      this.props.input.value.length &&
      this.props.input.value.indexOf(rowInfo.original[ItemEnum.ItemId]) !== -1
    ) {
      styleObj = style;
    }
    return {
      onClick: e => {
        const { direction, sortOptionsValue, dropDownValue } = this.props;
        const renderedComponent = getComponentOnSelection(
          sortOptionsValue,
          dropDownValue,
          direction
        );
        if (rowInfo && rowInfo.original) {
          if (
            isLeftSideItemGrid &&
            !isStorageLocationPage &&
            this.props.input.value &&
            this.props.input.value.length &&
            this.props.input.value.indexOf(
              rowInfo.original[ItemEnum.ItemId]
            ) === -1
          ) {
            const showUnsavedModal = !this.props.isReadOnly;
            this.setState(
              {
                showUnsavedModal: showUnsavedModal,
                rowInfo,
              },
              () => {
                if (!showUnsavedModal) {
                  this.getAssociatedGridDetails();
                  if (
                    renderedComponent ===
                      ComponentMapping.SiteToItemsComponents ||
                    renderedComponent ===
                      ComponentMapping.SiteGroupToItemsComponents
                  ) {
                    this.props.onResetPageOnDataChange({
                      ...GridResetInitialValueEnum,
                      [GridNames.Site]: false,
                      [GridNames.Item]: true,
                    });
                  } else if (
                    renderedComponent ===
                      ComponentMapping.ItemToSitesComponents ||
                    renderedComponent ===
                      ComponentMapping.ItemToSiteGroupsComponents
                  ) {
                    this.props.onResetPageOnDataChange({
                      ...GridResetInitialValueEnum,
                      [GridNames.Item]: false,
                      [GridNames.Site]: true,
                    });
                  }
                }
              }
            );
          } else if (isRightSideItemGrid) {
            if (
              renderedComponent === ComponentMapping.SiteToItemsComponents ||
              renderedComponent === ComponentMapping.ItemToSitesComponents ||
              renderedComponent ===
                ComponentMapping.SiteGroupToItemsComponents ||
              renderedComponent === ComponentMapping.ItemToSiteGroupsComponents
            ) {
              this.props.onResetPageOnDataChange({
                ...GridResetInitialValueEnum,
                [GridNames.Site]: false,
                [GridNames.Item]: false,
              });
            }
          } else if (isStorageLocationPage) {
            this.props.onResetPageOnDataChange({
              [GridNames.Site]: false,
              [GridNames.Item]: false,
            });
          }
        }
      },
      style: styleObj,
    };
  };

  render() {
    const {
      loadingAllItems,
      loadingStorageLocationById,
      rightSideGridReactTableRef,
      setItemGridInstance,
      dataSource,
      isStorageLocationPage,
      groupId_Cat,
      groupId_Bid,
      groupId_Item,
      prepareInHouse,
      vendorId,
      groupId_Location,
      onFilteredChange,
      isRightSideItemGrid,
      onRightGridFilteredChange,
      onResetPageOnDataChange,
      resetGridPage,
    } = this.props;

    let gridFilterValues = {},
      propFiltersValue = {};
    let newData = [];
    if (!this.props.isRightSideItemGrid) {
      propFiltersValue = {
        [FilterEnum.GroupId_Cat]: groupId_Cat,
        [FilterEnum.GroupId_Bid]: groupId_Bid,
        [FilterEnum.GroupId_Item]: groupId_Item,
        [FilterEnum.PrepareInHouse]: prepareInHouse,
        [FilterEnum.VendorId]: vendorId,
      };
      _.map(propFiltersValue, (value, key, items) => {
        if (+items[key]) {
          gridFilterValues[key] = items[key];
        }
      });
      if (!isStorageLocationPage && groupId_Location) {
        newData = getFilteredData(gridFilterValues, dataSource);
        newData = _.filter(newData, item => {
          if (Array.isArray(item[ItemEnum.StorageLocationIds])) {
            return item[ItemEnum.StorageLocationIds].includes(
              String(groupId_Location)
            );
          }
        });
      } else {
        newData = getFilteredData(gridFilterValues, dataSource);
      } //end of if "!isStorageLocationPage"
    }
    return (
      <Fragment>
        <Form.Field>
          <ReactTableWrapper
            reactTableRef={rightSideGridReactTableRef}
            minRows={0}
            loading={loadingAllItems || loadingStorageLocationById}
            data={
              isRightSideItemGrid
                ? this.prepareTableData()
                : newData
                ? newData
                : []
            }
            resizable={true}
            className={'-striped -highlight grid--fixed-row-height'}
            laodingText={loadingAllItems ? 'Loading...' : ''}
            noDataText={loadingAllItems ? '' : 'No items found'}
            saveState={{
              tableName: isStorageLocationPage
                ? TableNamesEnum.ASSIGN_ENTITIES_STORAGE_LOCATION_ITEM_GRID_TABLE
                : TableNamesEnum.ASSIGN_ENTITIES_ITEM_GRID_TABLE,
            }}
            menu={false}
            showHideColumn={false}
            draggableColumns={false}
            getTrProps={this.onRowClickProp}
            columns={this.state.columns}
            resetPageOnDataChange={resetGridPage[GridNames.Item]}
            onResetPageOnDataChange={onResetPageOnDataChange}
            onFilteredChange={
              isStorageLocationPage
                ? onRightGridFilteredChange
                : onFilteredChange
            }
            onRef={setItemGridInstance}
          />
        </Form.Field>
        <YesNoDialog
          showDialog={this.state.showUnsavedModal}
          title="Un-saved changes detected"
          question={UNSAVED_MESSAGE}
          yesCallback={() => {
            this.handleUnsavedModal(true);
          }}
          noCallback={() => {
            this.handleUnsavedModal(false);
          }}
        />
      </Fragment>
    );
  }
}

const assignEntitiesFormValueSelector = formValueSelector(
  ASSIGN_ENTITIES_FORM_NAME
);

const storageLocationFormValueSelector = formValueSelector(
  ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME
);

const mapStateToProps = (state, ownProps) => {
  const selector = ownProps.isStorageLocationPage
    ? storageLocationFormValueSelector
    : assignEntitiesFormValueSelector;

  return {
    SiteGridInfo: selector(state, AssignEntitiesEnum.SiteGridInfo),
    itemGridInfo: selector(state, AssignEntitiesEnum.ItemGridInfo),
    groupId_Bid: selector(state, FilterEnum.GroupId_Bid),
    groupId_Item: selector(state, FilterEnum.GroupId_Item),
    groupId_Cat: selector(state, FilterEnum.GroupId_Cat),
    groupId_Location: selector(state, FilterEnum.GroupId_Location),
    prepareInHouse: selector(state, FilterEnum.PrepareInHouse),
    vendorId: selector(state, FilterEnum.VendorId),
    sortOptionsValue: selector(state, AssignEntitiesEnum.SortOptions),
    dropDownValue: selector(state, AssignEntitiesEnum.To),

    loadingAllItems: Selectors.getLoadingAllItems(state),
    allItemsData: Selectors.getAllItemsData(state),
    allSitesData: Selectors.getAllSitesData(state),
    loadingStorageLocationById: Selectors.getLoadingStorageLocationById(state),
    sitesByItemId: Selectors.getSitesByItemId(state),
    siteGroupsByItemId: Selectors.getSiteGroupsByItemId(state),
  };
};

const mapDispatchToProps = {
  getSitesByItemId,
  getItems,
  getSiteGroupByItemId,
};

export const ItemGridContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemGrid);



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/containers/assignEntities/ItemGridContainer.js